import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AutomationHealthData {
  totalRules: number;
  rulesByType: { trigger_type: string; count: number }[];
  recentTriggers24h: number;
  triggersByType: { event_kind: string; count: number }[];
}

async function fetchAutomationHealth(): Promise<AutomationHealthData> {
  const { data, error } = await supabase.rpc('admin_automation_health');
  if (error) throw error;

  const d = data as {
    total_rules: number;
    rules_by_type: { trigger_type: string; count: number }[];
    recent_triggers_24h: number;
    recent_triggers_by_type: { event_kind: string; count: number }[];
  };

  return {
    totalRules: d.total_rules,
    rulesByType: d.rules_by_type ?? [],
    recentTriggers24h: d.recent_triggers_24h,
    triggersByType: d.recent_triggers_by_type ?? [],
  };
}

export function useAdminAutomationHealth(enabled: boolean, refetchInterval: number | false) {
  return useQuery({
    queryKey: ['admin-automation-health'],
    queryFn: fetchAutomationHealth,
    enabled,
    refetchInterval,
  });
}
